module.exports = __webpack_public_path__ + "static/media/purpose.d3946983.svg";